export const VALIDATE_REGISTRATION = 'VALIDATE_REGISTRATION';
export const REGISTRATION_OPTIONS = 'REGISTRATION_OPTIONS';
export const VALIDATE_REGISTRATION_OPTIONS = 'VALIDATE_REGISTRATION_OPTIONS';
export const VERIFY_VERIFICATION_CODE = 'VERIFY_VERIFICATION_CODE';
export const RESEND_VERIFICATION_CODE = 'RESEND_VERIFICATION_CODE';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const RESET_REGISTRATION_DATA = 'RESET_REGISTRATION_DATA';